// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensoryAnalystId } from './FoodSensoryAnalyst';
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodSensoryIntakeSubmissionId = (z.number());
export const foodSensoryIntakeSubmission = z.object({
    id: foodSensoryIntakeSubmissionId,
    email: z.string(),
    analyst_id: foodSensoryAnalystId.nullable(),
    answers: z.unknown(),
    passed: z.boolean(),
    follows_stop: z.boolean(),
    cleared_at: z.date().nullable(),
    cleared_by: operatorId.nullable(),
    invalidated_at: z.date().nullable(),
    invalidated_by: operatorId.nullable(),
    submitted_at: z.date(),
});
export const foodSensoryIntakeSubmissionInitializer = z.object({
    id: foodSensoryIntakeSubmissionId.optional(),
    email: z.string(),
    analyst_id: foodSensoryAnalystId.optional().nullable(),
    answers: z.unknown(),
    passed: z.boolean(),
    follows_stop: z.boolean().optional(),
    cleared_at: z.date().optional().nullable(),
    cleared_by: operatorId.optional().nullable(),
    invalidated_at: z.date().optional().nullable(),
    invalidated_by: operatorId.optional().nullable(),
    submitted_at: z.date().optional(),
});
export const foodSensoryIntakeSubmissionMutator = z.object({
    id: foodSensoryIntakeSubmissionId.optional(),
    email: z.string().optional(),
    analyst_id: foodSensoryAnalystId.optional().nullable(),
    answers: z.unknown().optional(),
    passed: z.boolean().optional(),
    follows_stop: z.boolean().optional(),
    cleared_at: z.date().optional().nullable(),
    cleared_by: operatorId.optional().nullable(),
    invalidated_at: z.date().optional().nullable(),
    invalidated_by: operatorId.optional().nullable(),
    submitted_at: z.date().optional(),
});
//# sourceMappingURL=FoodSensoryIntakeSubmission.js.map